import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Layout
import AppLayout from "../components/header.jsx";

// Pages
import AuthPage from "../pages/LoginPage.jsx";
import MpinSetupPage from "../pages/MpinPage.jsx";
import MpinResetPage from "../pages/resetMpin.jsx";
import ChangeMpin from "../pages/changeMpin.jsx";
import Dashboard from "../pages/Dashboard.jsx";
import ProfilePage from "../pages/ProfilePage.jsx";
import Feedback from "../pages/feedback.jsx";
import BookingEngine from "../pages/booking_tab.jsx";
import BookingEngine2 from "../pages/booking_tab2.jsx";
import BookingEngine3 from "../pages/booking_tab3.jsx";
import ActivityPage from "../pages/activity.jsx";
import BookingSuccess from "../pages/booking_confirm.jsx";
import Service from "../pages/service.jsx";
import MyBookings from "../pages/booking_history.jsx";
import InvoicePage from "../pages/invoice.jsx";
import TripsDashboard from "../pages/tripdashboard.jsx";
import Enquiry from "../pages/enquiry.jsx";
import Enquirypage from "../pages/enquiry2.jsx";
import BookingFail from "../pages/booking_Fail.jsx";
import RetryPayment from "../pages/retry_payment.jsx";
import PaymentHistory from "../pages/payment_history.jsx";
import ContactOfficePage from "../pages/ContactOfficePage.jsx";
import CustomerLiveMap from "../pages/CustomerLiveMap.jsx";

// Components
import PrivateRoute from "../components/PrivateRoute.jsx";

const AppRoutes = () => {
  const handleLogout = () => {
    localStorage.removeItem("customerToken");
    localStorage.removeItem("customerToken");
    window.location.href = "/login";
  };

  return (
    <Routes>
      {/* ---------- PUBLIC ROUTES ---------- */}
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<AuthPage />} />
      <Route path="/mpin-login" element={<AuthPage />} />

      {/* ---------- PROTECTED ROUTES (NO LAYOUT) ---------- */}
      <Route
        path="/setup-mpin"
        element={
          <PrivateRoute>
            <MpinSetupPage />
          </PrivateRoute>
        }
      />

      <Route
        path="/reset-mpin"
        element={
          <PrivateRoute>
            <MpinResetPage />
          </PrivateRoute>
        }
      />

      {/* ---------- PROTECTED ROUTES WITH LAYOUT ---------- */}
      <Route
        element={
          <PrivateRoute>
            <AppLayout handleLogout={handleLogout} />
          </PrivateRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/book-ride" element={<BookingEngine />} />
        <Route path="/local/search" element={<BookingEngine2 />} />
        <Route path="/oneway/search" element={<BookingEngine2 />} />
        <Route path="/roundtrip/search" element={<BookingEngine2 />} />
        <Route path="/taxi/search" element={<BookingEngine2 />} />
        <Route path="/booking" element={<BookingEngine3 />} />
        <Route path="/booking-success" element={<BookingSuccess />} />
        <Route path="/payment-failure" element={<BookingFail />} />
        <Route path="/retry-payment" element={<RetryPayment />} />
        <Route path="/payment-history" element={<PaymentHistory />} />

        <Route path="/activity-history" element={<ActivityPage />} />
        <Route path="/active-trip/:id" element={<TripsDashboard />} />

        <Route path="/services" element={<Service />} />
        <Route path="/booking-history" element={<MyBookings />} />
        <Route path="/invoice" element={<InvoicePage />} />

        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/enquiry/:id" element={<Enquirypage />} />

        <Route path="/profile" element={<ProfilePage />} />

        <Route path="/change-mpin" element={<ChangeMpin />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="/contact-office" element={<ContactOfficePage />} />
        <Route path="/live-track-ride/:enq_id" element={<CustomerLiveMap />} />
      </Route>

      {/* ---------- 404 ---------- */}
      <Route
        path="*"
        element={<h1 style={notFoundStyle}>404 - Page Not Found</h1>}
      />
    </Routes>
  );
};

const notFoundStyle = {
  textAlign: "center",
  marginTop: "50px",
  color: "white",
  fontFamily: "Inter, sans-serif",
};

export default AppRoutes;